import {createSelector} from '@ngrx/store';

import * as fromDesignationReducer from './designation.reducer';
import {AppState} from 'src/app/store/reducers';


export const currentState = (state: AppState) => (state[fromDesignationReducer.designationsFeatureKey]);

export const selectAllDesignations = createSelector(currentState, fromDesignationReducer.selectAll);

export const selectTotalDesignation = createSelector(currentState, fromDesignationReducer.selectTotal);

export const selectModifiedDesignation = createSelector(selectAllDesignations, (designations) => {
  return designations.map((designation) => {
    return {
      ...designation
    };
  });
});
